import { cn } from "@aichat/ui/lib/utils";
import { LucideProps } from "lucide-react";

const WhatsappIcon = ({
  filled,
  ...props
}: LucideProps & { filled?: boolean }) => {
  if (filled)
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 24.0547C18.6274 24.0547 24 18.6821 24 12.0547C24 5.42727 18.6274 0.0546875 12 0.0546875C5.37258 0.0546875 0 5.42727 0 12.0547C0 18.6821 5.37258 24.0547 12 24.0547Z"
          fill="#2AA81A"
        />
        <path
          d="M16.4994 7.55734C15.4385 6.4844 14.0289 5.82613 12.5252 5.70136C11.0215 5.57659 9.52267 5.99355 8.29942 6.87696C7.07617 7.76037 6.20907 9.05202 5.85467 10.5187C5.50027 11.9854 5.68192 13.5304 6.36683 14.8749L5.69579 18.1328C5.68861 18.1653 5.68833 18.199 5.69498 18.2317C5.70162 18.2643 5.71505 18.2952 5.73438 18.3224C5.76206 18.3634 5.80164 18.3951 5.84781 18.4131C5.89398 18.4311 5.94454 18.4345 5.99273 18.423L9.18012 17.6664C10.5209 18.3334 12.0549 18.5029 13.509 18.1449C14.9631 17.7868 16.2429 16.9244 17.1208 15.7112C17.9986 14.4979 18.4174 13.0125 18.3027 11.5194C18.188 10.0263 17.5472 8.62227 16.4944 7.55734H16.4994ZM15.5029 15.504C14.7692 16.2365 13.8243 16.7205 12.8012 16.8881C11.7781 17.0557 10.7282 16.8985 9.79915 16.4384L9.35291 16.217L7.39518 16.68V16.6548L7.80786 14.6803L7.58978 14.2509C7.11473 13.3193 6.94699 12.2611 7.11065 11.2283C7.2743 10.1954 7.76093 9.24094 8.5007 8.50182C9.42959 7.5739 10.6888 7.05268 12.0018 7.05268C13.3148 7.05268 14.574 7.5739 15.5029 8.50182L15.5247 8.53201C16.4415 9.46288 16.9533 10.7183 16.9486 12.0249C16.9439 13.3314 16.4231 14.5832 15.4996 15.5074L15.5029 15.504Z"
          fill="white"
        />
        <path
          d="M15.3307 14.0681C15.0908 14.4456 14.7099 14.9069 14.2352 15.0227C13.3964 15.224 12.1198 15.0227 10.521 13.5447L10.5009 13.5263C9.1102 12.2278 8.74113 11.1458 8.82333 10.2885C8.87198 9.80037 9.27796 9.36084 9.62018 9.0723C9.67459 9.02642 9.73898 8.99391 9.8082 8.97736C9.87742 8.9608 9.94955 8.96067 10.0188 8.97697C10.0881 8.99327 10.1526 9.02556 10.2072 9.07124C10.2618 9.11692 10.3049 9.17473 10.3332 9.24006L10.8482 10.4043C10.8818 10.4792 10.8944 10.5619 10.8846 10.6435C10.8749 10.725 10.8432 10.8024 10.7928 10.8673L10.5311 11.2028C10.4767 11.2725 10.4443 11.3567 10.438 11.4449C10.4318 11.533 10.4519 11.6211 10.4959 11.6977C10.7445 12.0641 11.0419 12.3948 11.38 12.6808C11.7437 13.0308 12.1562 13.3263 12.6046 13.5581C12.6864 13.5911 12.7762 13.599 12.8626 13.5808C12.9489 13.5626 13.0279 13.5191 13.0894 13.4558L13.3897 13.1505C13.4468 13.089 13.5199 13.0446 13.6007 13.0221C13.6815 12.9996 13.767 12.9999 13.8477 13.023L15.0723 13.3736C15.1417 13.3934 15.2055 13.4292 15.2585 13.4781C15.3114 13.5271 15.3522 13.5878 15.3773 13.6555C15.4025 13.7231 15.4114 13.7957 15.4032 13.8674C15.3951 13.9391 15.3703 14.0078 15.3307 14.0681Z"
          fill="white"
        />
      </svg>
    );

  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn(["w-5 h-5", props.className])}
    >
      <path
        d="M7.24578 5.83068C7.42467 5.83793 7.62258 5.84623 7.81062 6.26038C7.93913 6.54351 8.15535 7.07133 8.32767 7.49196C8.45464 7.80192 8.55778 8.05368 8.5844 8.10644C8.64716 8.23081 8.68897 8.37603 8.60531 8.54211C8.59278 8.56693 8.5812 8.59036 8.57013 8.61275C8.50725 8.73991 8.46104 8.83335 8.35456 8.95683C8.31282 9.00511 8.26968 9.05712 8.22653 9.10912C8.13989 9.21354 8.05323 9.31797 7.97799 9.39236C7.85209 9.51635 7.72132 9.65107 7.86774 9.89981C8.01422 10.1488 8.51798 10.9629 9.26417 11.622C10.0658 12.3302 10.7621 12.6297 11.1158 12.7818C11.1852 12.8117 11.2414 12.8359 11.2827 12.8564C11.5337 12.9807 11.6801 12.96 11.8265 12.7938C11.973 12.6279 12.4538 12.0679 12.6211 11.8192C12.7885 11.5702 12.9558 11.6117 13.1859 11.6946C13.4161 11.7775 14.6501 12.3792 14.9011 12.5036C14.95 12.5278 14.9958 12.5497 15.0382 12.57C15.2134 12.6538 15.3317 12.7103 15.3822 12.7938C15.445 12.8978 15.445 13.3955 15.2358 13.9762C15.0266 14.5569 14.0018 15.117 13.5416 15.1585C13.4973 15.1624 13.4533 15.1676 13.408 15.1729C12.9827 15.2224 12.4458 15.285 10.5295 14.5362C8.17159 13.6149 6.61686 11.3317 6.29566 10.86C6.26932 10.8213 6.25127 10.7948 6.24176 10.7823L6.23897 10.7786C6.10362 10.5994 5.21684 9.42512 5.21684 8.2101C5.21684 7.06477 5.78504 6.4644 6.04646 6.18817C6.06433 6.1693 6.08076 6.15193 6.09548 6.13601C6.32543 5.88713 6.59742 5.82485 6.76475 5.82485C6.77392 5.82485 6.78309 5.82485 6.79226 5.82485C6.95029 5.82483 7.10752 5.82481 7.24578 5.83068Z"
        fill="url(#paint0_linear_340_31752)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6264 15.3806C0.73469 13.8746 0.268565 12.1678 0.268565 10.4007C0.268565 4.91877 4.78794 0.460938 10.3206 0.460938C13.016 0.460938 15.5291 1.50511 17.4341 3.37258C19.3188 5.26013 20.3727 7.75009 20.3727 10.4208C20.3727 15.9027 15.8533 20.3605 10.3206 20.3605C8.63853 20.3605 6.97669 19.9589 5.51752 19.1557L0.1875 20.5413L1.6264 15.3806ZM3.2477 14.8184L3.45037 15.1196L2.59918 18.1718L5.76072 17.3485L6.06471 17.5292C7.34149 18.2923 8.82092 18.6939 10.3206 18.6939C14.9211 18.6939 18.6703 14.979 18.6703 10.4208C18.6703 8.21194 17.7989 6.12359 16.2181 4.55732C14.6576 3.01114 12.5499 2.14768 10.3206 2.14768C5.72019 2.14768 1.97093 5.84246 1.97093 10.4208C1.97093 11.967 2.41679 13.4931 3.2477 14.8184Z"
        fill="url(#paint1_linear_340_31752)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_340_31752"
          x1="0.1875"
          y1="10.5022"
          x2="20.3727"
          y2="10.5022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#20B038" />
          <stop offset="1" stopColor="#60D66A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_340_31752"
          x1="0.1875"
          y1="10.5022"
          x2="20.3727"
          y2="10.5022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#20B038" />
          <stop offset="1" stopColor="#60D66A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WhatsappIcon;
